import { Button, Switch, Table } from "antd";
import Column from "antd/lib/table/Column";
import React, { useState } from "react";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import AddEmployee from "./AddEmployee/AddEmployee";
import FilterEmployee from "./FilterEmployee/FilterEmployee";
import styles from "./Employees.module.css";
import EditEmployee from "./EditEmployee/EditEmployee";
import AddCity from "./AddCity/AddCity";
import useEmployees from "../../hooks/useEmployees";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import Location from "../../assets/svg/footer-location.svg";
import Edit from "../../assets/svg/edit-icon.svg";

export const Employees = () => {
  const [isEditEmployeeModalOpen, setIsEditEmployeeModalOpen] = useState(false);
  const [isAddCityModalOpen, setIsAddCityModalOpen] = useState(false);
  const {
    form,
    employees,
    addEmployeeState,
    handleChange,
    editEmployee,
    getEmployees,
    isLoading,
    search,
    setSearch,
    changePage,
    cities,
    setCities,
    getEmployeesReport,
  } = useEmployees();
  return (
    <>
      <Header
        title="Centers and Employees Management"
        activeItem={"CitiesAndUsers"}
        leftTitle={`Total Employees: ${employees?.length || 0}`}
      />
      <ContentCard
        filter={
          <FilterEmployee
            form={form}
            getEmployees={getEmployees}
            getEmployeesReport={getEmployeesReport}
            search={search}
            setSearch={setSearch}
            cities={cities}
            setCities={setCities}
          />
        }
        add={
          <AddEmployee
            state={addEmployeeState}
            handleChange={handleChange}
            getEmployees={getEmployees}
          />
        }
      >
        <Loading isLoading={isLoading}>
          <Table
            size="middle"
            scroll={{ x: 1920 }}
            dataSource={employees || []}
            pagination={{
              position: ["bottomCenter"],
              current: 1,
              pageSize: 10,
              total: 5,
              onChange: changePage,
            }}
          >
            <Column
              title={"#"}
              dataIndex="index"
              key="index"
              render={(_value, _item, index) => <>{index + 1}</>}
            />
            <Column
              title="Province"
              dataIndex="provinces"
              key="provinces"
              render={(provinces) => (
                <span>
                  {provinces.map((province) => province.name).join(", ")}
                </span>
              )}
            />
            <Column
              title="City"
              dataIndex="cities"
              key="cities"
              render={(cities) => (
                <span>{cities.map((city) => city.name).join(", ")}</span>
              )}
            />
            <Column
              title="Full Name"
              dataIndex="user"
              key="user"
              render={(user) => <span>{user.fullname}</span>}
            />
            <Column
              title="Position"
              dataIndex="post"
              key="post"
              render={(post) => <span>{post}</span>}
            />
            <Column
              title="National ID"
              dataIndex="user"
              key="user"
              render={(user) => <span>{user.national_id}</span>}
            />
            <Column
              title="Mobile Number"
              dataIndex="user"
              key="user"
              render={(user) => <span>{user.phone_number}</span>}
            />
            <Column
              title="Creation Date"
              dataIndex="created_at"
              key="created_at"
              render={(created_at) => <span>{created_at}</span>}
            />
            <Column
              title="Actions"
              render={(_v, data, index) => (
                <div
                  className={`flex-row flex-wrap w-300px  ${styles.Actions}`}
                >
                  <Switch
                    className="w-30 p-3"
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                    checked={data.is_active}
                    onChange={(checked) =>
                      editEmployee(
                        data.user.id,
                        null,
                        true,
                        checked ? "True" : "False"
                      )
                    }
                  />
                  <Button
                    className="button-white  mr-10"
                    onClick={() => setIsEditEmployeeModalOpen(index)}
                  >
                    <img src={Edit} width="25px" alt="Edit" />
                  </Button>
                  <EditEmployee
                    isModalOpen={isEditEmployeeModalOpen === index}
                    setIsModalOpen={setIsEditEmployeeModalOpen}
                    data={data}
                    addEmployeeState={addEmployeeState}
                    handleChange={handleChange}
                    editEmployee={editEmployee}
                  />
                  <Button
                    className="button-white  mr-10"
                    onClick={() => setIsAddCityModalOpen(index)}
                  >
                    <img src={Location} alt="Select City" width="25px" />
                  </Button>
                  <AddCity
                    isModalOpen={isAddCityModalOpen === index}
                    setIsModalOpen={setIsAddCityModalOpen}
                    data={data}
                    getEmployees={getEmployees}
                  />
                </div>
              )}
            />
          </Table>
        </Loading>
      </ContentCard>
    </>
  );
};
